var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 13.7534 33.7466 9.5 28.5 9.5L32.4373 5.56588C28.7267 1.85529 22.7106 1.85529 19 5.56588V0C13.7534 0 9.5 4.25345 9.5 9.5L5.56588 5.56588C1.85529 9.27647 1.85529 15.2894 5.56588 19H0C0 24.2466 4.25345 28.5 9.5 28.5L5.56269 32.4373C9.27328 36.1479 15.2894 36.1479 18.9968 32.4373V38.0032C24.2434 38.0032 28.4968 33.7497 28.4968 28.5032L32.4309 32.4373C36.1415 28.7267 36.1415 22.7138 32.4309 19.0032H37.9968L38 19Z",
    fill: "#F4DB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent3);
export default __webpack_public_path__ + "static/media/event-3.c36f2983e3d948902749e69b772e7798.svg";
export { ForwardRef as ReactComponent };